import { NavLink, Navigate, Route, Routes } from 'react-router-dom'
import { useAuth } from './store/auth'
import Login from './pages/Login'
import Esqueci from './pages/Esqueci'
import Redefinir from './pages/Redefinir'
import Senha from './pages/Senha'
import Inventario from './pages/Inventario'
import Editar from './pages/Editar'
import Historico from './pages/Historico'
import Catalogo from './pages/Catalogo'
import Comparar from './pages/Comparar'

const ABAS = [
  ['/', 'Inventário'],
  ['/editar', 'Editar'],
  ['/catalogo', 'Catálogo'],
  ['/comparar', 'Comparar'],
  ['/historico', 'Histórico'],
]

/**
 * As telas que abrem SEM sessão.
 *
 * Antes daqui o App devolvia `<Login />` direto quando não havia token, sem
 * olhar a rota — e com isso o link do e-mail de redefinição cairia na tela de
 * login, pedindo justamente a senha que a pessoa não tem. Quem chega por
 * `/redefinir?token=…` precisa chegar em `/redefinir`.
 */
function SemSessao() {
  return (
    <Routes>
      <Route path="/esqueci" element={<Esqueci />} />
      <Route path="/redefinir" element={<Redefinir />} />
      <Route path="*" element={<Login />} />
    </Routes>
  )
}

export default function App() {
  const { token, email, sair } = useAuth()

  if (!token) return <SemSessao />

  return (
    <div className="min-h-screen bg-zinc-50">
      <header className="border-b border-zinc-200 bg-white">
        <div className="mx-auto flex max-w-6xl flex-wrap items-center gap-x-6 gap-y-3 px-6 py-3">
          <span className="font-semibold text-zinc-900">Modelos</span>
          <nav className="flex gap-1">
            {ABAS.map(([para, rotulo]) => (
              <NavLink
                key={para}
                to={para}
                end={para === '/'}
                className={({ isActive }) =>
                  `rounded-lg px-3 py-1.5 text-sm font-medium ${
                    isActive ? 'bg-pinho-50 text-pinho-700' : 'text-zinc-500 hover:text-zinc-800'
                  }`
                }
              >
                {rotulo}
              </NavLink>
            ))}
          </nav>
          <div className="ml-auto flex items-center gap-3 text-xs text-zinc-500">
            <NavLink to="/senha" className="hover:text-zinc-800">{email}</NavLink>
            <button onClick={sair} className="text-zinc-400 hover:text-zinc-700">sair</button>
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-6xl px-6 py-8">
        <Routes>
          <Route path="/" element={<Inventario />} />
          <Route path="/editar" element={<Editar />} />
          <Route path="/catalogo" element={<Catalogo />} />
          <Route path="/comparar" element={<Comparar />} />
          <Route path="/historico" element={<Historico />} />
          <Route path="/senha" element={<Senha />} />
          {/* Quem já entrou e cai em /redefinir ou /esqueci veio do próprio
              console, não de um link de e-mail — o lugar dele é a troca de
              senha, que não exige link nenhum. */}
          <Route path="/redefinir" element={<Navigate to="/senha" replace />} />
          <Route path="/esqueci" element={<Navigate to="/senha" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </div>
  )
}
